/**
 * @generated SignedSource<<896db2f15538606e76c076eb4dc19d14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WhatToSeeEditMain_whatToSee$data = {
  readonly city: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly country: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly description: string | null;
  readonly id: string;
  readonly name: string;
  readonly pois: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly poisDescription: string | null;
  readonly region: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly " $fragmentType": "WhatToSeeEditMain_whatToSee";
};
export type WhatToSeeEditMain_whatToSee$key = {
  readonly " $data"?: WhatToSeeEditMain_whatToSee$data;
  readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeEditMain_whatToSee">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WhatToSeeEditMain_whatToSee",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "poisDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Country",
      "kind": "LinkedField",
      "name": "country",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Region",
      "kind": "LinkedField",
      "name": "region",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "City",
      "kind": "LinkedField",
      "name": "city",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Poi",
      "kind": "LinkedField",
      "name": "pois",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": null
    }
  ],
  "type": "WhatToSee",
  "abstractKey": null
};
})();

(node as any).hash = "91cef616c3f8d53be0ab17936f106c1c";

export default node;
